
// Token Model
export class Token {
  constructor(data = {}) {
    this.accessToken = data.accessToken || '';
    this.refreshToken = data.refreshToken || '';
    this.expiresIn = data.expiresIn || 3600;
  }
}
